























import { defineComponent, computed, ref, PropType } from '@nuxtjs/composition-api';
import { useTranslations } from '@vue-storefront/novulo';
import { addCurrency, priceFormat } from '~/helpers/utils';

type RelatedProduct = {
  spli_id?: number;
  product_id?: number;
  sku?: string;
  name: string;
  media?: string | null;
  product_image_gallery?: Array<{ media_url?: string }>;
  price?: number | null;
  price_after_cash_discount?: number | null;
  price_after_cashback_discount?: number | null;
  status?: string | null;
  status_reference?: number | null;
  url?: string;
  can_be_ordered?: boolean;
};

export default defineComponent({
  name: 'MiniCartDrawerAccessories',
  components: {
    MoleculesMiniCartDrawerAccessory: () => import('./MiniCartDrawerAccessory.vue')
  },
  props: {
    products: { type: Array as PropType<RelatedProduct[]>, default: () => [] },
    title: { type: String, default: '' }
  },
  emits: ['add'],
  setup(props, { emit }) {
    const { translate } = useTranslations();

    // normalize & filter (only show orderable accessories)
    const items = computed(() => {
      return (props.products || []).filter(p => p && p.can_be_ordered !== false);
    });

    const addedIds = ref<Set<string | number>>(new Set());
    const loadingIds = ref<Set<string | number>>(new Set());

    const handleAdd = async (payload: { product: RelatedProduct }) => {
      const key = payload.product.spli_id || payload.product.product_id || payload.product.sku;
      if (key === null) {
        emit('add', payload);
        return;
      }
      loadingIds.value.add(key);
      emit('add', payload);
      setTimeout(() => {
        loadingIds.value.delete(key);
        addedIds.value.add(key);
        // auto-clear green check after a short delay
        setTimeout(() => addedIds.value.delete(key), 1600);
      }, 450);
    };

    return {
      translate,
      addCurrency,
      priceFormat,
      items,
      addedIds,
      loadingIds,
      handleAdd
    };
  }
});
